<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <b-alert v-model="showAlert" variant="danger" dismissible>
            API token not valid!
          </b-alert>

          <b-form-group
            id="input-group-token"
            label-for="input-token"
            description="API token can be found in the backend config.yml file."
          >
            <b-form-input
              id="input-token"
              v-model="token"
              placeholder="Enter API token"
              required
            ></b-form-input>
          </b-form-group>

          <b-button @click="onSubmit()" type="submit" variant="primary" :disabled="disabledButton">Submit</b-button>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      token: null,
      showAlert: false
    }
  },
  computed: {
    disabledButton: function () {
      if (this.token === null) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    onSubmit () {
      let url = process.env.BASE_URL + '/api/login'
      let config = {
        headers: {
          Token: this.token
        }
      }

      axios.post(url, {}, config).then(response => {
        sessionStorage.setItem('token', this.token)
        this.$router.push('/ui/list')
      }).catch(err => {
        this.showAlert = true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue